import React, { PureComponent } from 'react';

interface Props {
  size: number;
}

class KnowBe4 extends PureComponent<Props> {
  render() {
    const { size = 24, ...otherProps } = this.props;
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        {...otherProps}
      >
        <path d="M12,0A12,12,0,1,0,24,12,12,12,0,0,0,12,0Zm6.485,18.281c-.067.069-.139.133-.212.2a1.019,1.019,0,0,1-.135.074q-.6-.678-1.171-1.319c2.778-3.107,3.3-6.417.778-9.863A6.95,6.95,0,0,0,9.958,5a7,7,0,0,0-4.8,5.592H6.986L3.974,14.651,1.674,10.6H3.213c.016-.131.038-.265.065-.4,0-.017.01-.034.014-.053.027-.118.054-.235.083-.351.007-.024.012-.048.019-.072h0a8.658,8.658,0,0,1,6.889-6.729,8.959,8.959,0,0,1,10.79,7.3A8.832,8.832,0,0,1,18.485,18.281Z" />
      </svg>
    );
  }
}

export default KnowBe4;
